"use client";

import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";

const SolidNavContext = createContext<{
  solid: boolean;
  setSolid: (next: boolean) => void;
}>({ solid: false, setSolid: () => {} });

export function SolidNavProvider({ children }: { children: ReactNode }) {
  const [solid, setSolid] = useState(false);
  const value = useMemo(() => ({ solid, setSolid }), [solid]);
  return <SolidNavContext.Provider value={value}>{children}</SolidNavContext.Provider>;
}

export function useSolidNav(): boolean {
  return useContext(SolidNavContext).solid;
}

export function SolidNav() {
  const { setSolid } = useContext(SolidNavContext);
  useEffect(() => {
    setSolid(true);
    return () => setSolid(false);
  }, [setSolid]);
  return null;
}
